<div data-cy="link-message-to-borrower-dialog">
    <h2 mat-dialog-title data-cy="link-message-to-borrower-dialog-header">Move to Existing Business</h2>
    <div>
      <div mat-dialog-content class="deal-status-reason-dialog">
        <p class="tw-pt-3">{{ messageIsEmail() ? data.message.fromEmail : data.message.fromNumber }}</p>
        <p class="tw-py-3">
          Please search and choose the business you would like to add this {{ messageIsEmail() ? 'email' : 'sms'}} to:
        </p>
        <div class="tw-border-2 tw-rounded-full tw-p-1">
            <app-borrower-search-input (borrower)="linkToBorrower($event)"></app-borrower-search-input>
        </div>
      </div>
      <mat-dialog-actions class="tw-float-right">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-flat-button 
            [mat-dialog-close]="responseData" 
            color="primary"
            [disabled]="!valid">Add to borrower</button>
      </mat-dialog-actions>
    </div>
  </div>
